import { mulberry32 } from './prng.ts'

// The desk field. Finite but larger than the fog radius everywhere along the flight
// path, so it reads as endless (ISSUES.md #6). Seeded: identical on every load.
export interface Desk {
  x: number
  z: number
  yaw: number
  monkey: boolean
  birth: number // uReveal threshold — the world grows outward from the hero desk
}

const rand = mulberry32(20260818)
const SX = 3.2
const SZ = 2.4

// z stops at ~77 so the field never leaks into the ARCHITECTURE corridor (z 84–114).
const desks: Desk[] = []
for (let ix = -18; ix <= 18; ix++) {
  for (let iz = -24; iz <= 32; iz++) {
    const x = ix * SX + (rand() * 2 - 1) * 0.35
    const z = iz * SZ + (rand() * 2 - 1) * 0.35
    const yaw = (rand() * 2 - 1) * ((6 * Math.PI) / 180)
    const monkey = rand() < 0.72
    if (Math.hypot(x - 2.2, z) < 3.0) continue // clearing around the hero desk
    desks.push({ x, z, yaw, monkey, birth: 1 })
  }
}

// birth -1: the hero desk is visible before any scroll, at any uReveal.
// yaw ≈ π: the monkey sits on the camera side, hunched over the desk, seen from behind
// in three-quarter profile — the reference composition.
const hero: Desk = { x: 2.2, z: 0, yaw: 2.75, monkey: true, birth: -1 }
desks.sort(
  (a, b) => Math.hypot(a.x - hero.x, a.z - hero.z) - Math.hypot(b.x - hero.x, b.z - hero.z),
)
desks.forEach((d, i) => {
  d.birth = 0.03 + 0.97 * (i / (desks.length - 1))
})

export const DESKS: Desk[] = [hero, ...desks]
export const DESK_TOP_Y = 0.75
